export default __webpack_public_path__ + "static/media/StonexOneLogo_dark.7ea15340.svg";